import React, { useEffect, useState } from "react";
import { Table, Modal, Tag, Popconfirm, notification } from "antd";
import { PlusCircle } from "react-feather";
import { Link } from "react-router-dom";
import { deleteJobType, getAllJobTypeMethod } from "../../service/ApiServices";
import CreateJobTypeModal from "../../core/modals/inventory/createJobType";
const JobType = () => {
  const [data, setData] = useState([]);
  const [isJobTypeAdd, setIsJobTypeAdd] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedJobType, setSelectedJobType] = useState(null);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const storedUserData = localStorage.getItem("user");
  const userData = JSON.parse(storedUserData);
  const roleName = userData?.data.role.roleName;

  const fetchData = async () => {
    setLoading(true);

    try {
      // Fetch job types
      const jobTypes = await getAllJobTypeMethod({ search, setLoading });
      console.log("Job Types", jobTypes);
      setData(jobTypes);
    } catch (error) {
      console.error("Error fetching job types:", error);
      // Optionally show an error message to the user
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchData();
      setSelectedJobType(null);
    }, 600);

    return () => {
      clearTimeout(handler);
    };
  }, [search, isJobTypeAdd]);

  useEffect(() => {
    if (isJobTypeAdd) {
      fetchData();
      setIsJobTypeAdd(false);
    }
  }, [isJobTypeAdd]);

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setSelectedJobType(null);
    setIsModalOpen(false);
  };

  const handleJobTypeAdding = () => {
    setIsJobTypeAdd(true);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "label",
      key: "label",
    },
    {
      title: "Styles",
      dataIndex: "styles",
      key: "styles",
      render: (styles) => {
        return styles.map((style, i) => (
          <Tag color={"orange"} key={i}>
            {style.styleName.toUpperCase()}
          </Tag>
        ));
      },
    },
    {
      title: "Price (Rs.)",
      dataIndex: "price",
      key: "price",
      align: "right",
    },
    {
      title: "Bundle",
      dataIndex: "isBulk",
      key: "isBulk",
      render: (isBulk) => (
        <Tag color={isBulk === 1 ? "gold-inverse" : "red"}>
          {isBulk === 1 ? "Yes" : "No"}
        </Tag>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <td className="action-table-data">
          <Link
            className="me-2 p-2"
            to="#"
            onClick={() => {
              setSelectedJobType(record);
              setIsModalOpen(true);
            }}
          >
            <i data-feather="edit" className="feather-edit"></i>
          </Link>
          {roleName === "Admin" && (
            <Popconfirm
              title="Delete the job type"
              description="Are you sure to delete this job type?"
              onConfirm={() => {
                deleteJobType(record).then(async (data) => {
                  if (data.status === 200) {
                    await fetchData();
                    notification.success({
                      message: data.data.message,
                      description: "Your operation was completed successfully.",
                      placement: "topRight", // Optional: 'topLeft', 'bottomRight', 'bottomLeft'
                    });
                  }
                });
              }}
              onCancel={() => {
                console.log("c");
              }}
              okText="Yes"
              cancelText="No"
            >
              <Link className="confirm-text p-2" to="#">
                <i data-feather="trash-2" className="feather-trash-2"></i>
              </Link>
            </Popconfirm>
          )}
        </td>
      ),
    },
  ];

  const expnadedColumns = [
    {
      title: "Name",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Styles",
      dataIndex: "styles",
      key: "styles",
      render: (styles) => {
        return styles.map((style, i) => (
          <Tag color={"orange"} key={i}>
            {style.styleName.toUpperCase()}
          </Tag>
        ));
      },
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Services</h4>
              <h6>Manage all your services from below</h6>
            </div>
          </div>
          <div className="page-btn">
            <a className="btn btn-added" onClick={() => setIsModalOpen(true)}>
              <PlusCircle className="me-2" />
              Add New Item
            </a>
          </div>
        </div>

        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  <Link className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="table-responsive">
              <Table
                loading={loading}
                columns={columns}
                dataSource={data}
                rowKey="value"
                pagination={false}
                expandable={{
                  expandedRowRender: (record) => (
                    <Table
                      columns={expnadedColumns}
                      dataSource={record.bundleItems}
                      pagination={false}
                    />
                  ),
                  rowExpandable: (record) => record.bundleItems.length > 0,
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <Modal
        zIndex={200000}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        maskClosable={false}
        closable={false}
      >
        <CreateJobTypeModal
          handleJobTypeAdding={handleJobTypeAdding}
          handleCancel={handleCancel}
          selectedJobType={selectedJobType}
        />
      </Modal>
    </div>
  );
};

export default JobType;
